import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const buyerUpdateStatusAPI = async (params, buyerId) => {
  return await axios({
    method: "put",
    url: `${config.api.base_url}dashboard/buyers/${buyerId}`,
    data: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default buyerUpdateStatusAPI;
